
import { useEffect, useRef, useState } from 'react';

interface UseIntersectionObserverOptions {
  threshold?: number;
  triggerOnce?: boolean;
  resetOnEachView?: boolean;
  rootMargin?: string;
}

export const useIntersectionObserver = (options: UseIntersectionObserverOptions = {}) => {
  const elementRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  const { 
    threshold = 0.1, 
    triggerOnce = true, 
    resetOnEachView = false,
    rootMargin = "0px" 
  } = options;

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;
    
    const observer = new IntersectionObserver(([entry]) => {
      // If entry is intersecting, make element visible
      if (entry.isIntersecting) {
        console.log("Element is visible:", entry.target);
        setIsVisible(true);
        
        // If triggerOnce is true and resetOnEachView is false, unobserve the element
        if (triggerOnce && !resetOnEachView) {
          observer.unobserve(entry.target);
        }
      } 
      // If resetOnEachView is true, set isVisible to false when element exits viewport
      else if (resetOnEachView) {
        console.log("Element is hidden:", entry.target);
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });

    observer.observe(element);

    return () => {
      observer.unobserve(element);
    };
  }, [threshold, triggerOnce, resetOnEachView, rootMargin]);

  return [elementRef, isVisible] as const;
};
